import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AboutComponent } from './about/about.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { HomeComponent } from './home/home.component';
import { HttpClientModule } from '@angular/common/http';
import {GenericService} from './services/generic.service';
// import { ProjectsComponent } from './projects/projects.component';
// import { ExperienceComponent } from './experience/experience.component';
// import { LighterComponent } from './lighter/lighter.component';
// import { SamplesComponent } from './samples/samples.component';
import { GenericComponent } from './generic/generic.component';
import { GenericDetailComponent } from './generic-detail/generic-detail.component';
import { RecentPostsComponent } from './sub-components/recent-posts/recent-posts.component';
import { LeftSideComponent } from './sub-components/left-side/left-side.component';
import { RightSideComponent } from './sub-components/right-side/right-side.component';
import { BlogComponent } from './blog/blog.component';
import { VideosComponent } from './videos/videos.component';
import { PhotosComponent } from './photos/photos.component';
import { PhotoDetailComponent } from './photo-detail/photo-detail.component';
import { PhotoComponent } from './photo/photo.component'
import { SplashComponent } from './splash/splash.component';
import { SplashScreenStateService } from './services/splash-screen-state-service';
import { SpinnerComponent } from './spinner/spinner.component';
import { AzureModernizingComponent } from './azure-modernizing/azure-modernizing.component';
import { AzureModernComponent } from './azure-modern/azure-modern.component';
import { DotnetComponent } from './dotnet/dotnet.component';

@NgModule({
  declarations: [
    AppComponent,
    AboutComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    // ProjectsComponent,
    // ExperienceComponent,
    // LighterComponent,
    // SamplesComponent,
    GenericComponent,
    GenericDetailComponent,
    RecentPostsComponent,
    LeftSideComponent,
    RightSideComponent,
    BlogComponent,
    VideosComponent,
    PhotosComponent,
    PhotoDetailComponent,
    PhotoComponent,
    SplashComponent,
    SpinnerComponent,
    AzureModernizingComponent,
    AzureModernComponent,
    DotnetComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule
  ],
  providers: [
    GenericService,
    SplashScreenStateService
  
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
